import { render, staticRenderFns } from "./MessageTypePerformanceTable.vue?vue&type=template&id=6cca9881"
import script from "./MessageTypePerformanceTable.vue?vue&type=script&lang=js"
export * from "./MessageTypePerformanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports